

import { EaseApp } from "es-uikit2";

const WebIM = EaseApp.getSdk({ appkey: "71117440#417715" });

export default WebIM;

